function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/require-default-props, react/forbid-prop-types */
import { bool, func, node, object, string } from "prop-types";
import React, { Component } from "react";
import PaymentController, { PAYMENT_CANCEL, PAYMENT_COMPLETE, PAYMENT_ERROR, PAYMENT_READY, PAYMENT_START, SCHEDULED_PAYMENT_CREATED, SCHEDULED_PAYMENT_CANCELED } from "./payment-controller";

var cachedController = void 0;

/**
 * The PaymentButton adds everything needed to use OneInc's PortalOne Payment
 * Modal, injecting their script, fetching session keys, and wiring up modal
 * events to props.
 *
 * @export
 * @class PaymentButton
 * @extends {Component}
 *
 * @example
 * <PaymentButton
 *   className="btn"
 *   controller={optionalPaymentController}
 *   payment={{
 *     accountBalance: "number",
 *     agencyLocationCode: "string",
 *     billingCity: "string",
 *     billingState: "string",
 *     billingStreet: "string",
 *     billingZip: "string",
 *     email: "string",
 *     firstName: "string",
 *     insightPolicyId: "string",
 *     lastName: "string",
 *     minAmountDue: "number",
 *     paymentApplicationClient: "string",
 *     phone: "string",
 *     policyId: "string",
 *     quoteId: "string",
 *     isScheduledPayEnabled: "bool",
 *     finalPayDate: "date"
 *   }}
 *   paymentsEndpoint="https://.../graphql"
 *   production={false}
 *   onPaymentStart={() => console.log("PAYMENT START")}
 *   onPaymentError={() => console.log("PAYMENT ERROR")}
 *   onPaymentCanceled={() => console.log("PAYMENT CANCELED")}
 *   onPaymentComplete={response => console.log("PAYMENT COMPLETE", response)}
 *   onScheduledPaymentCreated={response => console.log("SCHEDULED PAYMENT CREATED", response)}
 *   onScheduledPaymentCanceled={response => console.log("SCHEDULED PAYMENT CANCELED", response)}
 * >
 *   MAKE A PAYMENT
 * </PaymentButton>
 */

var PaymentButton = function (_Component) {
  _inherits(PaymentButton, _Component);

  function PaymentButton(props) {
    _classCallCheck(this, PaymentButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      loading: false,
      oneIncPortalReady: cachedController && cachedController.isReady()
    };
    return _this;
  }

  PaymentButton.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        controller = _props.controller,
        paymentsEndpoint = _props.paymentsEndpoint,
        production = _props.production,
        onPaymentStart = _props.onPaymentStart,
        onPaymentError = _props.onPaymentError,
        onPaymentCanceled = _props.onPaymentCanceled,
        onPaymentComplete = _props.onPaymentComplete,
        onScheduledPaymentCreated = _props.onScheduledPaymentCreated,
        onScheduledPaymentCanceled = _props.onScheduledPaymentCanceled;


    cachedController = cachedController || controller || new PaymentController({ paymentsEndpoint: paymentsEndpoint, production: production });

    if (cachedController.isReady()) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ oneIncPortalReady: true });
    }

    cachedController.addEventListener(PAYMENT_READY, function () {
      _this2.setState({ oneIncPortalReady: true });
    });
    cachedController.addEventListener(PAYMENT_START, function () {
      _this2.setState({ loading: false });
      if (onPaymentStart) onPaymentStart();
    });
    cachedController.addEventListener(PAYMENT_CANCEL, function () {
      _this2.setState({ loading: false });
      if (onPaymentCanceled) onPaymentCanceled();
    });
    cachedController.addEventListener(PAYMENT_ERROR, function (err) {
      _this2.setState({ loading: false });
      if (onPaymentError) onPaymentError(err);
    });
    cachedController.addEventListener(PAYMENT_COMPLETE, function (response) {
      if (onPaymentComplete) onPaymentComplete(response);
    });
    cachedController.addEventListener(SCHEDULED_PAYMENT_CREATED, function (response) {
      if (onScheduledPaymentCreated) onScheduledPaymentCreated(response);
    });
    cachedController.addEventListener(SCHEDULED_PAYMENT_CANCELED, function (response) {
      if (onScheduledPaymentCanceled) onScheduledPaymentCanceled(response);
    });
  };

  PaymentButton.prototype.handleClick = function handleClick() {
    this.setState({ loading: true });
    this.makePayment();
  };

  PaymentButton.prototype.makePayment = function makePayment() {
    cachedController.makePayment(this.props.payment);
  };

  PaymentButton.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        className = _props2.className,
        children = _props2.children;
    var _state = this.state,
        oneIncPortalReady = _state.oneIncPortalReady,
        loading = _state.loading;

    return React.createElement(
      "button",
      {
        className: className,
        onClick: function onClick() {
          return _this3.handleClick();
        },
        disabled: !oneIncPortalReady || loading
      },
      loading ? "Loading..." : children
    );
  };

  return PaymentButton;
}(Component);

export { PaymentButton as default };


PaymentButton.propTypes = process.env.NODE_ENV !== "production" ? {
  controller: object,
  payment: object,
  paymentsEndpoint: string,
  production: bool,
  onPaymentStart: func,
  onPaymentError: func,
  onPaymentCanceled: func,
  onPaymentComplete: func,
  onScheduledPaymentCreated: func,
  onScheduledPaymentCanceled: func,
  className: string,
  children: node
} : {};